import React from 'react'
import { Modal } from '../../../../../../../../../Components/Modal'
import { ModalTitle } from '../../../../../../../../../Components/Modal/ModalTitle'
import { ModalHeader } from '../../../../../../../../../Components/Modal/ModalHeader'
import { ModalBody } from '../../../../../../../../../Components/Modal/ModalBody'
import { ModalFooter } from '../../../../../../../../../Components/Modal/ModalFooter'
import  SubmitButton  from '../../../../../../../../../Components/Form/SubmitButton/index'


export const GenericModal = ({ onClose, title, message }) => {

    return (
      <Modal show={true} onHide={ onClose }>
        <ModalHeader>
          <ModalTitle>
            {title}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
            { message }
        </ModalBody>
        <ModalFooter>
          <SubmitButton value="Okay" onClick={ onClose } />
        </ModalFooter>
      </Modal>
    )
  }
